<template>
    <div>
        <h2 style="padding-top: 10px;">用户反馈</h2>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Form ref="formResponse" :label-width="80" :rules="ruleForm" :model="formResponse" style="padding-top: 10px;">
            <FormItem prop="selectCondition" label="反馈类型：">
                <Select v-model="formResponse.selectCondition">
                    <Option value="申述">申述</Option>
                    <Option value="咨询">咨询</Option>
                    <Option value="建议">建议</Option>
                    <Option value="报修">报修</Option>
                </Select>
            </FormItem>
            <FormItem prop="meterId" label="设备编号：">
                <Input v-model="formResponse.meterId" disabled placeholder="请输入设备编号..."></Input>
            </FormItem>
            <FormItem prop="customerName" label="用户姓名：">
                <Input v-model="formResponse.customerName" disabled placeholder="请输入用户姓名..."></Input>
            </FormItem>
            <FormItem prop="phoneNumber" label="手机号：">
                <Input v-model="formResponse.phoneNumber" disabled placeholder="请输入手机号..."></Input>
            </FormItem>
            <FormItem prop="address" label="地址：">
                <Input v-model="formResponse.address" disabled placeholder="请输入地址..."></Input>
            </FormItem>
            <FormItem prop="content" label="反馈内容：">
                <Input v-model="formResponse.content" placeholder="请输入反馈内容..." type="textarea" :autosize="{minRows: 2,maxRows: 10}"></Input>
            </FormItem>
        </Form>
        <Button ref="responseButton" :type="buttonType" size="large" long :loading="isLoadingButton" @click="commitResponse">{{buttonMsg}}</Button>
    </div>
</template>

<script>
    export default {
        data() {
            const validateContent = (rule, value, callback) => {
                console.log(value);
                if (value.trim() == "") {
                    callback(new Error('反馈内容不能为空...'));
                } else {
                    callback();
                }
            };
            return {
                height: document.body.clientHeight * 0.7,
                buttonType: "primary",
                isLoadingButton: false,
                isSpinShow: false,
                buttonMsg: "提交反馈",
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [],
                formResponse: {
                    selectCondition: "",
                    meterId: "",
                    customerName: "",
                    phoneNumber: "",
                    address: "",
                    content: ""
                },
                ruleForm: {
                    content: [{
                        validator: validateContent,
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            commitResponse() {
                var that = this;
                that.$refs['formResponse'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/response/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify({
                                responseType: that.formResponse.selectCondition,
                                responseMeterId: that.formResponse.meterId,
                                responseCustomerName: that.formResponse.customerName,
                                responseCustomerPhone: that.formResponse.phoneNumber,
                                responseCustomerAddress: that.formResponse.address,
                                responseContent: that.formResponse.content,
                                responseState: 0
                            }),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.formResponse.content = "";
                                that.$Notice.success({
                                    title: "提交成功"
                                });
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            },
                            complete: function() {
                                that.isLoadingButton = false;
                            }
                        });
                    }
                });
            },
            showCustomerDetails(param) {
                this.formResponse.selectCondition = "申述";
                this.formResponse.meterId = param.meterId;
                this.formResponse.customerName = param.customerName;
                this.formResponse.phoneNumber = param.customerPhone;
                this.formResponse.address = param.completeAddress;
            }
        }
    }
</script>

<style>
</style>
